export var dataHooks = {
  errorIndication: 'input-error-indication'
};